module.exports = __webpack_public_path__ + "src/img/index_menu/blue/2.png?d8ef0fe882739f51c8c0985d8a53fb90";


//////////////////
// WEBPACK FOOTER
// ./src/img/index_menu/blue/2.png
// module id = 184
// module chunks = 0